import { useQuery } from "@tanstack/react-query";
import type { DateTime } from "luxon";
import { useAnalytics } from "../../../contexts/analytics/hooks";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import { backendService } from "../../../services/backend.service";
import { MC_QUERY_DEFAULTS } from "../utils";

export const useGetDepartmentAlerts = ({
	sinceDate,
	endDate,
	isActual,
	roles,
	shiftHours,
	enabled,
}: {
	sinceDate: DateTime;
	endDate?: DateTime;
	isActual: boolean;
	roles?: string[];
	shiftHours?: string[];
	enabled?: boolean;
}) => {
	const { chosenDepartment } = useHospitalData();
	const { track } = useAnalytics();
	return useQuery({
		queryKey: [
			"department-alerts",
			sinceDate.toFormat("yyyy-MM-dd"),
			endDate?.toFormat("yyyy-MM-dd"),
			chosenDepartment.department_id,
			isActual,
			roles,
			shiftHours,
		],
		queryFn: async () => {
			track("fetch_department_alerts", {
				department_id: chosenDepartment.department_id,
				sinceDate: sinceDate.toFormat("yyyy-MM-dd"),
				endDate: endDate?.toFormat("yyyy-MM-dd"),
				is_actual: isActual,
			});
			const result = await backendService.getDepartmentAlerts({
				departmentId: chosenDepartment.department_id,
				startDate: sinceDate,
				endDate,
				isActual,
				roles,
				shiftHours,
			});
			return result.data;
		},
		...MC_QUERY_DEFAULTS,
		enabled,
	});
};
